import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeadRegNo from "./component";
import { fetchData } from "../lead-brands/actions";
import { setData, setStep, activateFirstStep, activateLastStep } from "../lead-form/actions";
import { resetRegistrationData } from "../car-registration-number/actions";

const mapStateToProps = ({
    brands: { isSSR, popular, all, elite},
    leadData,
    scrapCars
}) => {
    return {
        isSSR,
        popular,
        all,
        leadData,
        elite,
        scrapCars
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchDataConnect: fetchData,
    setDataConnect: setData,
    setStepConnect: setStep,
    resetRegistrationDataConnect: resetRegistrationData,
    activateFirstStepConnect: activateFirstStep,
    activateLastStepConnect: activateLastStep
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LeadRegNo);
